import Transform from '@app/transformers';

const sideloaded = window['__session__'] || {};
const auth = Transform.auth(sideloaded.user);

export const defaultState = {
  id: null,
  active_subscription: false,
  subscription: {},
  memberships: [],
  lastOrder: null,
  subdomain_name: null,
  wallpapers: [],
  email_background: null,
  use_email_background_for_all_profile_transfers: false,
  payment: {},
};

let accountState = defaultState;

if (auth) {
  accountState = {
    id: auth.account.id,
    active_subscription: auth.account.active_subscription || false,
    subscription: auth.subscription || {},
    memberships: auth.account.memberships || [],
    lastOrder: null, // TODO: move this out this store object
    subdomain_name: auth.account.subdomain_name,
    wallpapers: [],
    email_background: null,
    use_email_background_for_all_profile_transfers:
      auth.account.use_email_background_for_all_profile_transfers || false,
    payment: {},
  };
}

export default accountState;
